import { render, staticRenderFns } from "./TrajetMedicoAdministratif.vue?vue&type=template&id=278e8e7c"
import script from "./TrajetMedicoAdministratif.vue?vue&type=script&lang=js"
export * from "./TrajetMedicoAdministratif.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports